<template>
  <div>
    <c-notification
      v-if="!list.length"
      description="Leider konnten zu Ihrer Suchanfrage keine Ergebnisse gefunden werden. Bitte geben Sie einen anderen Suchbegriff ein oder ändern Sie die Filtereinstellungen."
      type="info"
    />

    <transition-group
      class="row icon-teaser-row"
      tag="div"
      name="icon-teaser-item"
    >
      <div
        v-for="teaser in list"
        :key="teaser.id"
        class="col-sm-6 col-lg-4 icon-teaser-item vertical-space"
      >
        <c-icon-teaser
          v-if="config.source === 'modules'"
          :title="teaser.title"
          :description="teaser.teaser"
          :type="teaser.type"
          :is-new="teaser.is_new"
          :url="teaser.url"
        />
        <c-event-teaser
          v-if="config.source === 'events'"
          :sim-games="teaser.sim_games"
          :event-type="teaser.event_type"
          :event-days="teaser.event_days"
          :city="teaser.city"
          :state="teaser.state"
          :digital="teaser.digital"
          :url="teaser.url"
        />
      </div>
    </transition-group>
  </div>
</template>

<script>
import CIconTeaser from './CIconTeaser.vue'
import CEventTeaser from './CEventTeaser.vue'
import CNotification from '../../../../vue/components/CNotification.vue'
import getSearchConfig from '../functions/get-search-config'

export default {
  name: 'CResults',

  components: {
    CIconTeaser,
    CEventTeaser,
    CNotification
  },

  props: {
    list: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      config: getSearchConfig()
    }
  }
}
</script>
